// Constants
import { VirtualListOrientation } from "./VirtualListWrapper";
// Styles
import { memoizeFunction, mergeStyles, concatStyleSets } from "@fluentui/react";
/**
 * Helper to get styles for VirtualListWrapper
 * @param orientation VirtualListOrientation
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((orientation, customStyles)=>{
    const VirtualListWrapperStyles = {
        anchor: [
            orientation === VirtualListOrientation.Horizontal && {
                // Make sure the anchor isn't 0px by 0px to avoid issues with InView not being called on old versions of Edge
                minWidth: "1px"
            },
            orientation === VirtualListOrientation.Vertical && {
                // Make sure the anchor isn't 0px by 0px to avoid issues with InView not being called on old versions of Edge
                minHeight: "1px"
            }
        ]
    };
    return concatStyleSets(VirtualListWrapperStyles, customStyles);
});
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        anchor: mergeStyles("virtualListAnchor", styles.anchor)
    }));
